/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import config from '@/config'

export default {
	UPDATE_AUTHENTICATED_USER(state, user) {
		localStorage.setItem('judgeInfo', JSON.stringify(user));
    localStorage.setItem('userRole', 'user');
  },
  SET_ACCESS_TOKEN(state, token) {
    localStorage.setItem(config.accessToken, token)
  }
}